import { render, staticRenderFns } from "./RegistraUtente.vue?vue&type=template&id=77d3c96e&scoped=true&"
import script from "./RegistraUtente.vue?vue&type=script&lang=js&"
export * from "./RegistraUtente.vue?vue&type=script&lang=js&"
import style0 from "./RegistraUtente.vue?vue&type=style&index=0&id=77d3c96e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d3c96e",
  null
  
)

component.options.__file = "RegistraUtente.vue"
export default component.exports